import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import { useWarehouseShippingMethods } from 'src/pages/settings/settingsRequests';

export const useWarehouseShippingMethodsTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status, loading } = useWarehouseShippingMethods();
  const columns: GridColDef[] = useMemo(() => [
    { field: 'Id', headerName: 'Id' },
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'LogisticsPartner', headerName: 'Logistics Partner' },
    { field: 'LogisticsPartnerCode', headerName: 'Logistics Partner Code' },
    { field: 'LogisticsPartnerServiceCode', headerName: 'Logistics Partner Service Code' },
    { field: 'ShipmentRequired', headerName: 'Shipment Required' },
    { field: 'DimensionRequired', headerName: 'Dimension Required' },
    { field: 'AlwaysPrintReturnLabel', headerName: 'Always Print Return Label' },
  ], []);
  const tableSettings = useTableSettings({ tableName: 'WarehouseShippingMethodsTable', idPath: ['Id'], columns, rows, status });
  tableSettings.loading = loading;
  return [columns, tableSettings];
};
